<template>
    <div>
        {{ display }}
    </div>
</template>

<script>
import { format } from "@/formatting/decimalFormatter";

export default {
    types: [
        "float",
        "double",
        "decimal"
    ],
    props: {
        value: {
            type: [ Number ],
            default: null,
        }
    },
    computed: {
        display() {
            return format(this.value);
        }
    }
};
</script>
